import { parseDataCurrencies } from "helpers";
import { Container } from "./style";
import { Currency as BoardCurrency } from "../../../Currencies/components";

export const Currency = ({ data, usdBlueTourist }) => {
  const { primary, secondary } = parseDataCurrencies(data, usdBlueTourist);

  const getNegative = (value) => {
    if (value.indexOf("-") > -1) {
      return <span className="variation-negative">{value}%</span>;
    }
    {
      return <span className="variation-positive">{value}%</span>;
    }
  };

  return (
    <Container>
      <BoardCurrency data={data} usdBlueTourist={usdBlueTourist} title="Cotización del dólar hoy" className="home" sponsor={true} />
      <p className="title-other">Cotización de otras divisas hoy</p>
      <div className="other-currency-grid">
        {secondary.map((element, index) => (
          <div className="card" key={`currencyCard${index}`}>
            <div className="card-content">
              <h2 className="dotted-border">{element.name}</h2>
              <div className="currency-info">
                <p className="dotted-border">
                  VENTA{" "}
                  <span className="sale">
                    {element.sellingRate}
                  </span>
                </p>
                <p className="dotted-border">
                  Valor anterior{" "}
                  <span>{element.last}</span>
                </p>
                <p className="dotted-border">
                  Variación
                  {getNegative(element.variation)}
                </p>
                <p className="dotted-border">
                  COMPRA{" "}
                  <span className="sale">
                    {element.buyingRate}
                  </span>
                </p>
              </div>
              <p className="last-value">
                Último valor obtenido el <span>{element.update}</span>
              </p>
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
};
